'use client';

import { captureCartGuestMerge, CART_GUEST_MERGE_KEY } from '@/domain/cart/selection/guest-merge';
import { AppStoreContext } from '@/providers/app-store-provider';
import { resolveCartSelectionIdentity } from '@/utils/cart-selection-identity';
import logger from '@/utils/client-logger';
import { env } from '@/utils/env';
import { useContext, useEffect } from 'react';

/** 订阅同步 token 边界，覆盖普通/App 登录；初始已登录恢复不视为游客合并。 */
export function useCartGuestSelectionMerge() {
  const store = useContext(AppStoreContext);
  useEffect(() => {
    if (!store) return;
    return store.subscribe((next, previous) => {
      if (next.token === previous.token || !previous.clientTokenReady) return;
      try {
        sessionStorage.removeItem(CART_GUEST_MERGE_KEY);
        // 非购物车页（尤其 WAP）可能尚未解析 AB，应用时再由 V1 控制器隔离。
        if (previous.token || !next.token) return;
        const guestIdentity = resolveCartSelectionIdentity({
          authenticated: false,
          visitorId: previous.visitorId,
        });
        const sessionIdentity = resolveCartSelectionIdentity({
          authenticated: true,
          token: next.token,
        });
        if (!guestIdentity || !sessionIdentity) return;
        captureCartGuestMerge({
          guestScope: {
            site: env.NEXT_PUBLIC_SITE_NAME || 'us',
            currency: previous.currency.name,
            identity: guestIdentity,
          },
          sessionIdentity,
          groups: previous.canBuyList,
          storage: localStorage,
          pendingStorage: sessionStorage,
        });
      } catch (error) {
        logger.error('Failed to capture guest cart selection:', error);
      }
    });
  }, [store]);
}
